let selectedPipelineHistoryCols = [
    {
        key: 'RuleId',
        display: 'RuleId'
    },
    {
        key: 'RuleName',
        display: 'RuleName'
    },
    {
        key: 'StatusText',
        display: 'StatusText'
    },
    {
        key: 'ParamResults[0].Name',
        display: 'ParamResults[0].Name'
    },
    {
        key: 'ParamResults[0].Expected',
        display: 'ParamResults[0].Expected'
    },
    {
        key: 'ParamResults[0].Value',
        display: 'ParamResults[0].Value'
    },
    {
        key: 'ParamResults[1].Name',
        display: 'ParamResults[1].Name'
    },
    {
        key: 'ParamResults[1].Expected',
        display: 'ParamResults[1].Expected'
    },
    {
        key: 'ParamResults[1].Value',
        display: 'ParamResults[1].Value'
    },
    {
        key: 'ParamResults[2].Name',
        display: 'ParamResults[2].Name'
    },
    {
        key: 'ParamResults[2].Expected',
        display: 'ParamResults[2].Expected'
    },
    {
        key: 'ParamResults[1].Value',
        display: 'ParamResults[2].Value'
    }]

export { selectedPipelineHistoryCols }